import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import MoreVert from '@material-ui/icons/MoreVert';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import LockIcon from '@material-ui/icons/Lock';
import RefreshIcon from '@material-ui/icons/Refresh';
import AssessmentIcon from '@material-ui/icons/Assignment';
import FolderIcon from '@material-ui/icons/Folder';
import AddIcon from '@material-ui/icons/CreateNewFolder';
import { toggleAddProgrammePopup } from '../redux/reducers/view';
import { NavLink } from 'react-router-dom';
import AvatarCirce from './AvatarCircle';

import Typography from '@material-ui/core/Typography';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


import { commonStyles, COLORS } from '../styles/styles';

import { authAdminRequest, authUserRequest, getTokenFromCookies, logoutUserRequest } from '../redux/reducers/login';
import {
  
  getUserProgramsFullRequest,
 
} from '../redux/reducers/userProgramsFull';
import {
  
  DeactivateRequest,
 
} from '../redux/reducers/deactivate';
import {
  
  systemRequest,
 
} from '../redux/reducers/system';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import { xapiRequest } from '../redux/reducers/xapi';


const ProfileMenu = ({ classes, 
  anchorEl, 
  handleMenuToggle, 
  loginReducer, 
  logoutUserRequest, 
  toggleAddProgrammePopup,
  getUserProgramsFullRequest, 
  deactivate, 
  handleRetry,
  handleAlert,
  showAlert,
  showSystemAlert,
  handleOk, 
  system
 }) => {
  const open = Boolean(anchorEl);
  return (
    <div style={{position:'absolute', top:0, right:0}}>
      <IconButton
        aria-owns={open ? 'menu-appbar' : null}
        aria-haspopup="true"
        onClick={handleMenuToggle}
        color="inherit"
      >
        <MoreVert />
      </IconButton>
      
      <Drawer anchor="right" open={open} onClose={handleMenuToggle}>
      <div
      className={classes.list}
      role="presentation"
      onClick={handleMenuToggle}
      onKeyDown={handleMenuToggle}
    >
     
      {}
      <ListItem button key={'profile'}>
      <AvatarCirce
        senderName={`${loginReducer.user.firstName} ${loginReducer.user.lastName}`}
        bg="#FFFFFF"
        color={COLORS.cornerstoneRed}
        withBorder
        size={25}
      />
      <Typography className={`${classes.itemName}`}>
        {`${loginReducer.user.firstName} ${loginReducer.user.lastName}`}
      </Typography>
      </ListItem>
      <Divider />
      <List>
          <ListItem button key={'Refresh'}  onClick={() => getUserProgramsFullRequest()}>
          <ListItemIcon>
            <RefreshIcon />
          </ListItemIcon>
            <ListItemText primary={'Refresh'} />
          </ListItem>
          <ListItem button key={'AddProgram'}  onClick={() => toggleAddProgrammePopup(true)}>
          <ListItemIcon>
            <AddIcon />
          </ListItemIcon>
            <ListItemText primary={'Add New Program'} />
          </ListItem>
       
      </List>
      <Divider />
      <List>
          <ListItem button key={'logout'}  onClick={() => {
              this.props.xapiRequest({xapiType: 'Logged Out'})
              setTimeout(() => {
                this.props.logoutUserRequest(this.props.loginReducer.token)
              }, 4000);
            
              localStorage.setItem('firstShowTourPopup', false);
            }}>
           <ListItemIcon>
            <InboxIcon />
          </ListItemIcon>
            <ListItemText primary={"Logout"} />
          </ListItem>
          <ListItem button key={'deactivate'}  onClick={() => {
              handleAlert();
            }}>
           <ListItemIcon>
            <LockIcon />
          </ListItemIcon>
            <ListItemText primary={"Deactivate Account"} />
          </ListItem>
      </List>
    </div>
      </Drawer>
      {showAlert && <Dialog
        open={showAlert}
        onClose={handleAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Deactivation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
         Your account has been successfully deactivated
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>  handleOk()} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>}
      {showSystemAlert && <Dialog
        open={showSystemAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
        {system.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>  handleRetry()} color="primary">
           Retry
          </Button>
        </DialogActions>
      </Dialog>}
    </div>
  );
};

const styles = () => ({
  ...commonStyles,
  menuItem: {
    margin: '-8px 0',
  },
});

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  system: state.systemReducer.system,
});
const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  logoutUserRequest: token => dispatch(logoutUserRequest(token)),
  toggleAddProgrammePopup: value => dispatch(toggleAddProgrammePopup(value)),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  deactivate: () => dispatch(DeactivateRequest()),
  systemRequest: () => dispatch(systemRequest()),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  xapiRequest: value => dispatch(xapiRequest(value)),

});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('anchorEl', 'handleToggleMenu', null),
  withState('showAlert', 'toggleShowAlert', false),
  withState('showSystemAlert', 'toggleShowSystemAlert', false),
  withHandlers({
    handleMenuToggle: props => event => {
      props.handleToggleMenu(props.anchorEl === null ? event.currentTarget : null);
    },
    handleAlert: props => () => {
      const { showAlert } = props;
      props.deactivate();
      props.toggleShowAlert(!showAlert);
    },
    handleOk: props =>  () => {
     this.props.xapiRequest({xapiType: 'Logged Out'})
      
     setTimeout(() => {
      this.props.logoutUserRequest(this.props.loginReducer.token)
    }, 4000);
     
      //localStorage.setItem('firstShowTourPopup', false);
    },
    handleRetry: props => () => {
     props.systemRequest();
    }
  }),
  lifecycle ({
    componentWillReceiveProps(nextProps){
      
      if(nextProps.system && nextProps.system.success==true && nextProps.system!=this.props.system){
        
        this.props.toggleShowSystemAlert(nextProps.system.success)
      }else if (nextProps.system && nextProps.system!=this.props.system){
       
        this.props.toggleShowSystemAlert(nextProps.system.success)
      }
    }
  }
  ),
  withStyles(styles),
)(ProfileMenu);

ProfileMenu.propTypes = {
  classes: PropTypes.instanceOf(Object),
  anchorEl: PropTypes.instanceOf(Object),
  handleMenuToggle: PropTypes.func,
  loginReducer: PropTypes.instanceOf(Object),
  logoutUserRequest: PropTypes.func,
};
